/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CableMaterialTypeEnum = 1 | 2;

export const CableMaterialTypeEnum = {
    NUMBER_1: 1 as CableMaterialTypeEnum,
    NUMBER_2: 2 as CableMaterialTypeEnum
};

